import { getFreshToken } from './firebase';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

/**
 * Wrapper around fetch for CMS API calls.
 *
 * - Gets a fresh Firebase ID token before every request (the SDK caches
 *   valid tokens, so this is cheap when the token is still good).
 * - On a 401 response, force-refreshes the token once and retries.
 */
export async function cmsFetch(path, options = {}) {
  const doFetch = async (forceRefresh = false) => {
    const token = await getFreshToken(forceRefresh) || localStorage.getItem('cms_token');

    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
      'Authorization': `Bearer ${token}`,
    };

    const url = path.startsWith('http') ? path : `${BACKEND_URL}${path}`;
    return fetch(url, { ...options, headers });
  };

  let response = await doFetch(false);

  // Retry once with a force-refreshed token on 401
  if (response.status === 401) {
    response = await doFetch(true);
  }

  return response;
}
